import React, {Component} from 'react'
import Thumb from './ThumbProject'
import {style} from 'glamor'

export default class extends Component {

  render(){
    const {items, pathname, ...props} = this.props
    return (
      <div
        {...props}
        {...style({
          width: '100%'
        })}
      >
        {items.map((item, i)=>(
          <Thumb
            key={i}
            title={item.title}
            // image={item.images[0].src}
            image={item.image && `/images/category/${item.image }`}
            to={`${pathname}/${item.id}`}
          />
        ))}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ProjectList.js
 **/